function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 72.9001C16.8 73.7286 16.1285 74.4001 15.3 74.4001C14.4716 74.4001 13.8 73.7286 13.8 72.9001C13.8 72.0717 14.4716 71.4001 15.3 71.4001C16.1285 71.4001 16.8 72.0717 16.8 72.9001Z",
  fill: "#FF9900"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0097 26.4C66.0097 27.0627 65.4703 27.6 64.8049 27.6C64.1395 27.6 63.6001 27.0627 63.6001 26.4C63.6001 25.7372 64.1395 25.2 64.8049 25.2C65.4703 25.2 66.0097 25.7372 66.0097 26.4Z",
  fill: "#FF9900"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M71.9999 17.9928C71.9999 18.983 71.194 19.7856 70.1999 19.7856C69.2058 19.7856 68.3999 18.983 68.3999 17.9928C68.3999 17.0026 69.2058 16.2 70.1999 16.2C71.194 16.2 71.9999 17.0026 71.9999 17.9928Z",
  fill: "#FFCE88"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8333 64.1667C22.8333 63.5223 23.3556 63 24 63C24.6443 63 25.1666 63.5223 25.1666 64.1667L25.1666 66.0333H27.0333C27.6776 66.0333 28.2 66.5557 28.2 67.2C28.2 67.8443 27.6776 68.3667 27.0333 68.3667H25.1666L25.1666 70.2333C25.1666 70.8777 24.6443 71.4 24 71.4C23.3556 71.4 22.8333 70.8777 22.8333 70.2333V68.3667H20.9666C20.3223 68.3667 19.8 67.8443 19.8 67.2C19.8 66.5557 20.3223 66.0333 20.9666 66.0333H22.8333V64.1667Z",
  fill: "#FFCE88"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5 2.5C57.5 1.11929 58.6193 9.07511e-07 60 7.86805e-07C61.3807 6.66099e-07 62.5 1.11929 62.5 2.5L62.5 6.5L66.5 6.5C67.8807 6.5 69 7.61929 69 9C69 10.3807 67.8807 11.5 66.5 11.5L62.5 11.5L62.5 15.5C62.5 16.8807 61.3807 18 60 18C58.6193 18 57.5 16.8807 57.5 15.5L57.5 11.5L53.5 11.5C52.1193 11.5 51 10.3807 51 9C51 7.61929 52.1193 6.5 53.5 6.5L57.5 6.5L57.5 2.5Z",
  fill: "#FF9900"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8229 7.2348L37.9556 8.17373L37.9553 8.17587C51.9262 10.1752 61.6058 23.4651 59.6148 38.0019C57.6239 52.5387 44.7112 62.8548 30.6972 61.1703L30.6756 61.1673C30.5883 61.1568 30.501 61.1457 30.4137 61.1342C30.2324 61.1104 30.0522 61.0851 29.8732 61.0584L23.5685 60.2028L23.6746 59.4278L30.8229 7.2348Z",
  fill: "#B1BCCC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0595 7.26718L38.14 8.19926L38.1398 8.2014C52.0084 10.1873 61.6055 23.4663 59.6146 38.0031C57.6236 52.5399 44.7935 62.8669 30.8817 61.1958L30.8602 61.1929C30.7736 61.1824 30.6869 61.1715 30.6002 61.16C30.4202 61.1363 30.2413 61.1112 30.0637 61.0848L23.805 60.2352L23.9112 59.4601L31.0595 7.26718Z",
  fill: "#F6F7FA"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_13281_878)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.9178,
  height: 53.2101,
  transform: "matrix(0.389327 -0.922526 -0.946066 -0.320878 62.0801 68.7847)",
  fill: "#718096"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26.9178,
  height: 53.2101,
  transform: "matrix(0.389327 -0.922526 -0.946066 -0.320878 52.8398 84.5408)",
  fill: "#323A47"
}));

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.3503,
  ry: 26.2875,
  transform: "matrix(-0.991447 -0.130513 -0.135693 0.990751 28.7265 34.2062)",
  fill: "#F6F7FA"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.3222,
  cy: 33.9757,
  rx: 26.9636,
  ry: 27.0116,
  fill: "#E2E8F0"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13281_878)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.051 24.9719H33.5666V28.4727H44.051V24.9719ZM26.5749 28.4727H23.08V31.9756H26.5749V28.4727ZM23.08 45.981H26.5749V35.4764H23.08V45.981ZM30.0697 28.4727V31.9756H33.5666V28.4727H30.0697ZM30.0697 45.981H33.5666V35.4764H30.0697V45.981ZM30.0697 24.9719H26.5749V28.4727H30.0697V24.9719ZM12.5935 24.9719V28.4727H23.08V24.9719H12.5935ZM44.051 35.4764V31.9756H33.5666V35.4764H44.051ZM26.5749 31.9756V35.4764H30.0697V31.9756H26.5749ZM12.5935 31.9756V35.4764H23.08V31.9756H12.5935Z",
  fill: "#0A0806"
}));

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.2788,
  cy: 34.3014,
  rx: 23.5437,
  ry: 23.569,
  stroke: "#C5CEDC",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDasharray: "0.5 5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M7.98314 51.7167C7.98314 50.6582 8.84126 49.8 9.8998 49.8C10.9583 49.8 11.8165 50.6582 11.8165 51.7167L11.8165 54.7834L14.8831 54.7834C15.9417 54.7834 16.7998 55.6415 16.7998 56.7C16.7998 57.7586 15.9417 58.6167 14.8831 58.6167L11.8165 58.6167L11.8165 61.6834C11.8165 62.7419 10.9584 63.6 9.89981 63.6C8.84126 63.6 7.98314 62.7419 7.98314 61.6834L7.98314 58.6167L4.91647 58.6167C3.85792 58.6167 2.9998 57.7586 2.9998 56.7C2.9998 55.6415 3.85792 54.7834 4.91647 54.7834L7.98314 54.7834L7.98314 51.7167Z",
  fill: "#FF9900"
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13281_878"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31.4575,
  height: 21.009,
  fill: "white",
  transform: "translate(12.5935 24.9719)"
})));

const SvgEarnThresholdTokens = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13281_878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 7,
    width: 37,
    height: 55
  }, _ref8), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEarnThresholdTokens, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/earn-threshold-tokens.849465e7.svg";
export { ForwardRef as ReactComponent };